import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { encapsulation } from '../../components/encapsulation';
import { UBXColor } from '../../models';

@Component({
    selector: 'ubx-message',
    templateUrl: './message.component.html',
    host: { class: 'ubx-message flx-i p:rl bdr:1 pd:15' },
    encapsulation
})
export class UBXMessageComponent implements OnInit {
    @Input() type: UBXColor = UBXColor.Inf;

    constructor() { }

    @HostBinding('class') get classes(): string {
        return this.setClass('bdr-clr', this.type);
    }

    ngOnInit() {}

    setClass(type: string, value: string): string {
        return `${type}:${value}`;
    }

    setIcon(type: UBXColor): string {
        let icon: string;
        switch (type) {
            case UBXColor.Inf:
                icon = 'status.info reg.cir';
                break;
            case UBXColor.Scs:
                icon = 'interface.check reg.cir';
                break;
            case UBXColor.Dgr:
                icon = 'alert.exclaimation reg.tri';
                break;
            case UBXColor.Wrn:
                icon = 'alert.exclaimation reg.cir';
                break;
        }
        return icon;
    }
}
